"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualPauseSection = void 0;
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const ui_1 = require("@app/component/ui");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const form_grid_layout_1 = require("../../../ui/forms/form-grid-layout");
const manual_pause_item_1 = require("../components/manual-pause-item");
const shift_modal_section_1 = require("../components/shift-modal-section");
const shift_context_1 = require("../shift-context");
const detect_start_duration_overlap_1 = require("../util/detect-start-duration-overlap");
const getPauseStartErrors = (overlaps, period, field, index) => {
    const _overlaps = overlaps.some((overlap) => overlap.secondOverlapIndex === index);
    if (_overlaps) {
        return {
            hasError: true,
            errorMessage: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('ERR_MESSAGE.shift.pauseOverlap')),
            error: ' ',
        };
    }
    if (field.start < 0) {
        return {
            hasError: true,
            errorMessage: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('ERR_MESSAGE.shift.pauseOutsideShift')),
        };
    }
    const minuteDiff = (0, moment_1.default)(period.end)
        .startOf('minute')
        .diff((0, moment_1.default)(period.start)
        .startOf('minute')
        .add(field.start + field.duration, 'minutes'), 'minutes');
    if (minuteDiff < 0) {
        return {
            hasError: true,
            errorMessage: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('ERR_MESSAGE.shift.pauseOutsideShift')),
            error: ' ',
        };
    }
};
const ManualPauseSection = () => {
    const { formControl, toggledSections, disabledEditation } = (0, shift_context_1.useShift)();
    const { fields, update, remove, append } = (0, react_hook_form_1.useFieldArray)({
        control: formControl,
        name: 'pauses',
        keyName: 'pauseFieldId',
        rules: {
            validate: (pauses, form) => {
                if (toggledSections.includes('automatic-pause')) {
                    return true;
                }
                const overlaps = (0, detect_start_duration_overlap_1.detectOverlaps)(pauses);
                const errors = pauses
                    .map((pause, index) => getPauseStartErrors(overlaps, form.period, pause, index))
                    .filter(util_1.isDefined);
                return errors.at(0)?.errorMessage;
            },
        },
    });
    const pauseOverlaps = (0, detect_start_duration_overlap_1.detectOverlaps)(fields);
    const period = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'period' });
    return (react_1.default.createElement(shift_modal_section_1.ShiftModalSection, { id: 'manual-pause', headerContent: react_1.default.createElement(ui_1.Button, { style: 'BORDERLESS', ico: 'plus', onClick: () => {
                const lastPause = fields.length ? fields[fields.length - 1] : null;
                append(lastPause
                    ? { start: lastPause.start + 240, duration: lastPause.duration }
                    : { start: 240, duration: 30 });
            }, disabled: (0, util_1.isDefined)(disabledEditation) }, (0, util_1.t)('ADD_PAUSE')) },
        react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '0.5rem' } }, fields.map((field, index) => (react_1.default.createElement(react_1.default.Fragment, { key: field.pauseFieldId },
            react_1.default.createElement("div", { style: {
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'end',
                    position: 'relative',
                } },
                react_1.default.createElement("div", { style: { position: 'absolute', bottom: '-1.5rem' } },
                    react_1.default.createElement(ui_1.Button, { color: 'RED', style: 'BORDERLESS', ico: 'delete', onClick: () => remove(index), disabled: (0, util_1.isDefined)(disabledEditation) }, (0, util_1.t)('DELETE')))),
            react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
                react_1.default.createElement(manual_pause_item_1.ManualPauseItem, { index: index, field: field, update: update, error: getPauseStartErrors(pauseOverlaps, period, field, index) }))))))));
};
exports.ManualPauseSection = ManualPauseSection;
